import { Button } from '@tblabs/truffle';


export class TouchButton extends Button
{
    constructor(label: string, private onDown?: () => void, private onUp?: () => void)
    {
        super(label);

        this.Class("uk-button uk-button-primary")
            .Style("white-space: nowrap;");

        // this.On("mousedown", () => this.KeyDown());
        // this.On("touchstart", () => this.KeyDown());
        this.On("pointerdown", () => this.KeyDown());
        // this.On("mouseup", () => this.KeyUp());
        // this.On("touchend", () => this.KeyUp());
        this.On("pointerup", () => this.KeyUp());
    }

    private KeyDown()
    {
        this.Background("#f0506e");
        this.onDown?.();
    }

    private KeyUp()
    {
        this.Background("#1e87f0");
        this.onUp?.();
    }
}
